import { physiqueAuthInstance } from '../../service/physique.service';

export const profileService = {
  getPatientInfo() {
    return physiqueAuthInstance
      .get('/profile')
      .then((response) => response.data)
      .catch((error) => {
        const { response } = error;
        if (response.status === 401) {
          window.location.href = '/login';
        }
      });
  },
  updatePatientInfo(data) {
    return physiqueAuthInstance
      .post('/profile/personal', data)
      .then((response) => response.data)
      .catch((e) => {
        console.log(e);
      });
  },
};
